import { withCompInfo } from '@wix/editor-elements-integrations'
import type { MenuProps } from './Menu'
import type { MenuItemProps } from '@wix/thunderbolt-becky-types'

export const props = withCompInfo<MenuProps, any>()(
	// @ts-ignore
	['compData', 'hasResponsiveLayout', 'responsiveContainerProps', 'containerRootClassName'],
	({
		compData,
		hasResponsiveLayout,
		// @ts-ignore
		responsiveContainerProps: containerProps,
		// @ts-ignore
		containerRootClassName,
	}) => {
		return {
			...(compData?.a11y?.label && {
				a11y: { label: compData?.a11y?.label },
			}),
			...(hasResponsiveLayout && {
				containerProps,
				containerRootClassName,
			}),
			items: (compData.menuRef as unknown) as Array<MenuItemProps>,
		}
	}
)
